import {
    GET_ADMIN,
    ADD_ADMIN,
    UPDATE_ADMIN,
    DELETE_ADMIN
} from "./actions.type";
import {adminService} from "../service/adminService";

function initState() {
    return {
        list: [],
    }
}

const state = initState();

const actions = {

    async [GET_ADMIN]({commit}, id) {
        let result = await adminService.getAdmin(id);
        commit(GET_ADMIN, result.data);
    },

    // eslint-disable-next-line no-unused-vars
    async [ADD_ADMIN]({commit}, data) {
        return await adminService.addAdmin(data);
    },

    // eslint-disable-next-line no-unused-vars
    async [UPDATE_ADMIN]({commit}, data) {
        return await adminService.updateAdmin(data);
    },

    // eslint-disable-next-line no-unused-vars
    async [DELETE_ADMIN]({commit}, id) {
        return await adminService.deleteAdmin(id);
    },
};

const mutations = {
    [GET_ADMIN](state, admin) {
        state.list = admin;
    }
};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};
